<template>
  <div
    aria-live="assertive"
    class="pointer-events-none fixed inset-0 z-50 flex items-end px-4 py-6 sm:items-end sm:p-6"
  >
    <div class="flex w-full flex-col items-center space-y-4 sm:items-end">
      <div
        v-if="text"
        class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-neutral-700 shadow-lg ring-1 ring-white ring-opacity-5"
      >
        <div class="p-4" id="infoNotification">
          <div class="flex items-start">
            <div class="flex-shrink-0">
              <InformationCircleIcon class="text-emerald h-6 w-6" />
            </div>
            <div class="ml-3 w-0 flex-1 pt-0.5">
              <p class="mt-1 text-sm">{{ text }}</p>
            </div>
            <div v-if="close" class="ml-4 flex flex-shrink-0">
              <button type="button" @click="$emit('update:info', '')" class="inline-flex rounded-md focus:outline-none">
                <span class="sr-only">{{ $t("msg.closePopupMessage") }}</span>
                <XMarkIcon class="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { InformationCircleIcon, XMarkIcon } from "@heroicons/vue/24/outline";

defineProps({
  text: {
    type: String,
    required: true,
  },
  close: {
    type: Boolean,
    default: true,
  },
});

defineEmits(["update:info"]);
</script>
